import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { puedeVer } from '@/constants/roles';

interface InicioSegunRolProps {
    dashboard: ReactNode;
    supervisor: ReactNode;
}

/**
 * Decide en qué pantalla aterriza cada rol al entrar a `/`.
 *
 * Antes todos caían en el Dashboard, que muestra indicadores de toda la empresa.
 * Un funcionario no tiene por qué verlos, así que se lo lleva a la primera
 * pantalla que sí le corresponde.
 *
 * El orden importa: se va de lo más específico a lo más general, y el último
 * caso muestra un mensaje en lugar de redirigir. Redirigir a alguien sin
 * ninguna pantalla asignada crearía un bucle contra su propia guarda.
 */
export function InicioSegunRol({ dashboard, supervisor }: InicioSegunRolProps) {
    const role = useAuthStore((s) => s.role);

    if (role === 'supervisor') return <>{supervisor}</>;
    if (puedeVer(role, 'dashboard')) return <>{dashboard}</>;
    if (puedeVer(role, 'horarios')) return <Navigate to="/horarios" replace />;

    return (
        <div className="flex h-full min-h-[60vh] flex-col items-center justify-center px-6 text-center">
            <h2 className="text-xl font-semibold">Tu cuenta todavía no tiene pantallas asignadas</h2>
            <p className="mt-2 max-w-md text-sm text-muted-foreground">
                Pedile a un administrador que revise el rol de tu usuario.
            </p>
        </div>
    );
}
